import React, { FC } from 'react'
import { Link } from 'react-router-dom'
//import RedirectFromOldUrl from "../RedirectFromOldUrl";
import { Helmet } from 'react-helmet'

const NotFound: FC = () => {
  return (
    <>
      <Helmet>
        <meta name='robots' content='noindex, nofollow' />
      </Helmet>
      <div className='page--100vh-min page-404 warranty-log'>
        <div className='page-title'>
          <h1 className='title'>Page not found</h1>
        </div>

        <div className='error'>
          <div className='error__pic'>
            <img src='images/error.jpg' alt='' />
          </div>
          <div className='error__content'>
            <div className='error__title'>error 404</div>
            <div className='error__text'>
              The page you are looking for <br /> does not exist
            </div>
            <a href='/'>Back to home</a>
          </div>
        </div>
      </div>
    </>
  )
}

export default NotFound
